import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/flightSearchSection/FlightSearch.js");
;
import(/* webpackMode: "eager", webpackExports: ["JsonLdScript"] */ "/app/src/components/JsonLdScript.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/pageBuilder/PageBuilderClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ProductNavigationTabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VirtualPvEvent.js");
;
import(/* webpackMode: "eager", webpackExports: ["componentRegistry","itemPropMapping"] */ "/app/src/configs/common/landing-pages/home/registry.js");
;
import(/* webpackMode: "eager" */ "/app/src/configs/common/landing-pages/styles/landing-pages.module.css");
